enum CvVideoRejectionReason {
  MEANS_OF_CONTACT = 'means_of_contact',
  OFFENSIVE_WORDS = 'offensive_words',
  BAD_QUALITY = 'bad_quality',
  TOO_LONG = 'too_long',
  TOO_SHORT = 'too_short',
}

export default CvVideoRejectionReason;
